module.exports = __webpack_public_path__ + "img/bild3.e0808c66.jpeg";